import React from 'react';

const Home = ({ onNavigate }) => {
  const isLoggedIn = !!localStorage.getItem('authToken');
  const userName = localStorage.getItem('userName');

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            M<span className="highlight">u</span>DA
          </h1>
          <p className="hero-subtitle">
            Conectando Restaurantes e Agricultores Locais
          </p>
          <p className="hero-description">
            A plataforma inteligente que revoluciona a forma como seu restaurante compra ingredientes frescos, 
            reduz custos e apoia a agricultura local.
          </p>
          
          <div className="hero-cta">
            {isLoggedIn ? (
              <button 
                className="btn-hero-primary" 
                onClick={() => onNavigate('Perfil')}
              >
                🏪 Ir para Meu Perfil
              </button>
            ) : (
              <>
                <button 
                  className="btn-hero-primary" 
                  onClick={() => onNavigate('Cadastro')}
                >
                  Começar Agora - Grátis
                </button>
                <button 
                  className="btn-hero-secondary" 
                  onClick={() => onNavigate('Login')}
                >
                  Já tenho conta
                </button>
              </>
            )}
          </div>

          {isLoggedIn && (
            <div className="hero-welcome">
              👋 Bem-vindo(a), <strong>{userName || 'Usuário'}</strong>!
            </div>
          )}
        </div>
      </section>

      {/* Problem Section */}
      <section className="problem-section">
        <div className="section-content">
          <h2 className="section-title">Desafios que Você Enfrenta Diariamente</h2>
          <div className="problems-grid">
            <div className="problem-card">
              <div className="problem-icon">💸</div>
              <h3>Custos Elevados</h3>
              <p>Intermediários encarecem produtos frescos, impactando sua margem de lucro.</p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">⏰</div>
              <h3>Perda de Tempo</h3>
              <p>Buscar fornecedores confiáveis e comparar preços consome horas valiosas.</p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">📉</div>
              <h3>Qualidade Inconsistente</h3>
              <p>Difícil garantir produtos frescos e de qualidade todos os dias.</p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">🤝</div>
              <h3>Falta de Conexão</h3>
              <p>Agricultores locais próximos, mas sem forma eficiente de encontrá-los.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="solution-section">
        <div className="section-content">
          <h2 className="section-title">Nossa Solução Inteligente</h2>
          <p className="section-subtitle">
            O Muda usa tecnologia e IA para conectar você diretamente aos melhores agricultores locais
          </p>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Matching Inteligente</h3>
              <p>
                Algoritmo que encontra agricultores próximos com os produtos que você precisa, 
                economizando tempo e dinheiro.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📍</div>
              <h3>Busca por Proximidade</h3>
              <p>
                Defina o raio de busca e encontre fornecedores locais automaticamente, 
                reduzindo custos de logística.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🤖</div>
              <h3>IA para Recomendações</h3>
              <p>
                Receba sugestões personalizadas baseadas no seu histórico e necessidades do cardápio.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">💬</div>
              <h3>Contato Direto</h3>
              <p>
                Comunique-se diretamente com agricultores, negocie preços e construa parcerias duradouras.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Gestão de Insumos</h3>
              <p>
                Controle seu estoque de ingredientes e receba alertas quando precisar reabastecer.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🌱</div>
              <h3>Impacto Sustentável</h3>
              <p>
                Apoie a agricultura local, reduza pegada de carbono e fortaleça a economia regional.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="section-content">
          <h2 className="section-title">Benefícios Reais para Seu Negócio</h2>
          
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-number">01</div>
              <div className="benefit-content">
                <h3>Economia de até 30%</h3>
                <p>Elimine intermediários e compre direto do produtor com preços justos para ambos.</p>
              </div>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-number">02</div>
              <div className="benefit-content">
                <h3>Produtos Mais Frescos</h3>
                <p>Receba ingredientes colhidos há poucas horas, garantindo qualidade máxima aos seus pratos.</p>
              </div>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-number">03</div>
              <div className="benefit-content">
                <h3>Menos Tempo Comprando</h3>
                <p>Encontre fornecedores em minutos, não em horas. Foque no que realmente importa: sua cozinha.</p>
              </div>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-number">04</div>
              <div className="benefit-content">
                <h3>Diferencial Competitivo</h3>
                <p>Marketing natural: "Ingredientes de agricultores locais" atrai clientes conscientes.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section className="audience-section">
        <div className="section-content">
          <h2 className="section-title">Feito Para Você</h2>
          
          <div className="audience-grid">
            <div className="audience-card">
              <div className="audience-icon">🍽️</div>
              <h3>Restaurantes</h3>
              <p>
                De bistrôs a estabelecimentos de grande porte, encontre fornecedores locais 
                confiáveis e economize nas compras.
              </p>
              <ul className="audience-list">
                <li>✓ Gestão de insumos simplificada</li>
                <li>✓ Busca automática por proximidade</li>
                <li>✓ Histórico de pedidos e favoritos</li>
              </ul>
            </div>
            
            <div className="audience-card">
              <div className="audience-icon">👨‍🌾</div>
              <h3>Agricultores</h3>
              <p>
                Venda diretamente para restaurantes da sua região, elimine atravessadores 
                e aumente sua margem de lucro.
              </p>
              <ul className="audience-list">
                <li>✓ Cadastro gratuito de produtos</li>
                <li>✓ Visibilidade para restaurantes próximos</li>
                <li>✓ Receba pedidos diretamente</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final Section */}
      <section className="cta-section">
        <div className="section-content">
          <h2 className="cta-title">Pronto para Mudar?</h2>
          <p className="cta-description">
            Junte-se a centenas de restaurantes e agricultores que já estão economizando e crescendo juntos.
          </p>
          
          {!isLoggedIn && (
            <div className="cta-buttons">
              <button 
                className="btn-cta-primary" 
                onClick={() => onNavigate('Cadastro')}
              >
                Criar Conta Grátis
              </button>
              <button 
                className="btn-cta-secondary" 
                onClick={() => onNavigate('Login')}
              >
                Fazer Login
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Home;